import { observable } from "mobx";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class RegionSimpleListResponse {
  /**
   * Payment template ID.
   */
  id!: string;

  /**
   * Payment template code.
   */
  @observable
  name!: string;

  /**
   * Flag indicating if payment template is deleted.
   */
  @observable
  isDeleted!: boolean;

  /**
   * NUTS code of the region (e.g. "CZ020" for the Central Bohemian Region).
   */
  @observable
  nutsCode!: string;
}
